export default "__VITE_ASSET__EeyhJB0b__"